import React, { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'css/GamePageTabView/styles.scss';
import Hint from '../hint/Hint';
import BetRowView from '../BetRowView/BetRowView';
import RequestBet from '../../features/RequestBet';
import { detectMobile, scrollToTop } from '../../utils/UiHelper';
import {
    SPORTS,
    MARKET_TYPE_GROUPS_ID,
    CUSTOM_BET_ALLOWED_LIVE_SPORT_ID,
    CUSTOM_BET_ALLOWED_PRE_SPORT_ID,
} from '../../constants/appConfig';
import PlayerGroup from '../PlayerGroup';
import ViewOddsPlayerGroup from '../ViewOddsPlayerGroup';
import Button from '../../ui/Button';
import darkArrow from '../../images/arrowRight.svg';
import { ControlsWrapper } from '../big9/styled';
import CustomBetRecommendation from '../../features/CustomBetRecommendation/CustomBetRecommendation';

const SPILLER_MARKETS_IDS = [
    MARKET_TYPE_GROUPS_ID.SPILLER_SPECIALS.KORT,
    MARKET_TYPE_GROUPS_ID.SPILLER_SPECIALS.MAL,
];

const GamePageTabView = ({
    markets,
    uiActions,
    auth,
    eventObject,
    eventId,
}) => {
    const HINT_TEXT = {
        title: 'Byg væddemål:',
        mobTitle: 'Byg væddemål',
        description:
            'Byg din egen kupon med Byg væddemål og kombiner op til 10 udfald i samme kamp. Hvis ét udfald på din kupon annulleres, bliver hele kuponen annulleret og du får din indsats retur.',
    };
    const checkDefaultIndex = () => {
        if (window.locationHistory[0] === '/kupon') {
            return Number(localStorage.getItem('TabIndexState'));
        } else {
            return 0;
        }
    };

    const [tabIndexState, setTabIndexState] = useState(checkDefaultIndex());
    const [disabledLeftButton, setDisabledLeftButton] = useState(true);
    const [disabledRightButton, setDisabledRightButton] = useState(false);

    useEffect(
        () => {
            localStorage.setItem('TabIndexState', `${tabIndexState}`);
        },
        [tabIndexState]
    );

    useEffect(() => {
        scrollToTop();
        setTimeout(() => {
            checkDisabledArrow();
        }, 100);
    }, []);

    useEffect(() => {
        let tabList = document.getElementById('tabList');
        tabList.addEventListener('scroll', checkDisabledArrow);
        tabList.addEventListener('resize', checkDisabledArrow);
        return () => {
            tabList.removeEventListener('scroll', checkDisabledArrow);
            tabList.removeEventListener('resize', checkDisabledArrow);
            setDisabledLeftButton(true);
            setDisabledRightButton(false);
        };
    }, []);

    const checkDisabledArrow = () => {
        let tabList = document.getElementById('tabList');
        let elementWidth = tabList?.offsetWidth > 0 ? tabList.offsetWidth : 0;
        let scrollLeft = tabList?.scrollLeft > 0 ? tabList.scrollLeft : 0;
        let rightSide = Math.round(elementWidth + scrollLeft);
        let leftSide = tabList?.scrollWidth > 0 ? tabList.scrollWidth : 0;

        setDisabledRightButton(leftSide - rightSide < 3);

        setDisabledLeftButton(scrollLeft === 0);
    };

    const scrollToRight = () => {
        let tabList = document.getElementById('tabList');
        let leftOffsetPosition = tabList.scrollLeft + 200;

        tabList.scroll({
            left: leftOffsetPosition,
            behavior: 'smooth',
        });
    };

    const scrollToLeft = () => {
        let tabList = document.getElementById('tabList');
        let leftOffsetPosition = tabList.scrollLeft - 200;

        tabList.scroll({
            left: leftOffsetPosition,
            behavior: 'smooth',
        });
    };

    const getTabItems = (offer) => {
        return offer.map((item, index) => {
            return (
                <Tab key={item.marketTypeGroupName + index}>
                    {item.marketTypeGroupName}
                </Tab>
            );
        });
    };

    const groupMarketsByHomeAway = (markets, homeAway) => {
        let filteredMarkets = [...markets];

        return filteredMarkets.map((market) => {
            let filteredMarket = Object.assign({}, market);

            //TODO check fix for spiller live event
            filteredMarket.itemList = market.itemList
                .filter((item) => item.odds > 1)
                .sort((a, b) => a.odds - b.odds)
                .filter((player) => parseInt(player.homeDrawAway) === homeAway);
            return filteredMarket;
        });
    };

    let getTabPanel = (markets) => {
        return markets.map((item, key) => {
            let isCustomBet = item.marketTypeGroupName === 'Byg væddemål';
            return (
                <TabPanel className={'tabPanel'} key={'panel' + key}>
                    {item.marketTypeGroup ===
                        MARKET_TYPE_GROUPS_ID.BET_REQUEST ||
                    item.marketTypeGroupName === 'Kundeønsker' ? (
                        <RequestBet
                            uiActions={uiActions}
                            user={auth?.user}
                            event={eventObject}
                        />
                    ) : null}

                    {item?.marketList?.length > 0 &&
                        item?.marketList[0]?.itemList &&
                        getRowView(item, isCustomBet)}
                </TabPanel>
            );
        });
    };

    const groupByEventName = (array) => {
        return array.reduce((result, currentItem) => {
            (result[currentItem.marketType] =
                result[currentItem.marketType] || []).push(currentItem);
            return result;
        }, {});
    };

    const getRowView = (item, isCustomBet) => {
        if (
            SPILLER_MARKETS_IDS.includes(item.marketTypeGroup) ||
            (item.marketTypeGroup === MARKET_TYPE_GROUPS_ID.SPILLERE &&
                item.marketList[0].sportId === SPORTS.FOOTBALL)
        ) {
            return getSpecialEvent(item);
        } else if (isCustomBet) {
            let groupedCBMarkets = groupByEventName(item.marketList);

            return Object.keys(groupedCBMarkets).map((objectKey, index) => {
                return (
                    <BetRowView
                        market={groupedCBMarkets[objectKey]}
                        marketName={objectKey}
                        isOpenRow={true}
                        key={index + 'betrow_CB'}
                        isCustomBet={isCustomBet}
                        isFirstElement={index === 0}
                    />
                );
            });
        } else {
            return item.marketList.map((list, index) => {
                let hasDisabledMarket = [];
                list.itemList.map((item) => {
                    if (item.odds === 1) {
                        hasDisabledMarket.push(true);
                    }
                });

                if (hasDisabledMarket.length !== list.itemList.length) {
                    return (
                        <BetRowView
                            market={list}
                            marketName={list.marketName}
                            marketId={list.marketId}
                            isOpenRow={true}
                            key={index + 'betrow'}
                            isCustomBet={isCustomBet}
                        />
                    );
                } else {
                    return null;
                }
            });
        }
    };

    const getSpecialEvent = (item) => {
        if (
            item.marketTypeGroup ===
                MARKET_TYPE_GROUPS_ID.SPILLER_SPECIALS.KORT &&
            eventObject &&
            eventObject.data &&
            !eventObject.data.live /*Display only on pre events*/
        ) {
            return (
                <BetRowView
                    spillerLabel={item.marketList[0].marketTypeName}
                    children={
                        <ViewOddsPlayerGroup
                            marketList={item.marketList}
                            filterColumn={(label) =>
                                label.toLowerCase().includes('kort i kampen')
                            }
                            labelFormatter={(label) => {
                                switch (label) {
                                    case 'Kort i kampen - Første':
                                        return 'Første';
                                    case 'Modtager et kort i kampen':
                                        return 'Kort';
                                    case 'Kort i kampen - Sidste':
                                        return 'Sidste';
                                    case 'Rødt kort i kampen':
                                        return 'Rødt';
                                    default:
                                        return label;
                                }
                            }}
                            rowLimit={7}
                        />
                    }
                />
            );
        }
        if (
            item.marketTypeGroup === MARKET_TYPE_GROUPS_ID.SPILLERE &&
            item.marketList[0] &&
            item.marketList[0].sportId &&
            item.marketList[0].sportId === SPORTS.FOOTBALL
        ) {
            let groupedMarkets = [
                groupMarketsByHomeAway(item.marketList, 1),
                groupMarketsByHomeAway(item.marketList, 2),
            ];
            return groupedMarkets.map((item, index) => {
                return (
                    <BetRowView
                        key={index}
                        children={
                            <PlayerGroup
                                markets={item}
                                allMarkets={item.marketList}
                            />
                        }
                        spillerLabel={
                            index === 0
                                ? 'Målscorere - Hjemmehold'
                                : 'Målscorere - Udehold'
                        }
                    />
                );
            });
        }
        if (
            item.marketTypeGroup === MARKET_TYPE_GROUPS_ID.SPILLER_SPECIALS.MAL
        ) {
            item.marketList.forEach((el) => {
                el.itemList.forEach((item) => {
                    item.bet = item.competitor.replace(/\d+\+/g, '');
                });
            });
            return (
                <BetRowView
                    spillerLabel={item.marketList[0].marketTypeName}
                    children={
                        <ViewOddsPlayerGroup
                            marketList={item.marketList}
                            rowKey={'bet'}
                            rowLimit={7}
                        />
                    }
                />
            );
        }
    };

    const tabPanel = getTabPanel(markets);

    const showBetbuilder = () => {
        return (
            (markets &&
                markets.length > 0 &&
                markets[0]?.marketTypeGroupName === 'Mest populære odds' &&
                (checkDefaultIndex() || tabIndexState === 0)) ||
            (markets &&
                markets.length > 0 &&
                markets[1]?.marketTypeGroupName === 'Byg væddemål' &&
                tabIndexState === 1)
        );
    };

    const checkConditionForBetRec = (sportId) => {
        return (
            eventObject &&
            eventObject.pending === false &&
            eventObject.data &&
            ((eventObject.data.live === false &&
                CUSTOM_BET_ALLOWED_PRE_SPORT_ID.includes(sportId)) ||
                (eventObject.data.live &&
                    CUSTOM_BET_ALLOWED_LIVE_SPORT_ID.includes(sportId)))
        );
    };

    return (
        <>
            <Tabs
                className={'tabsWrapper'}
                onSelect={(index) => {
                    setTabIndexState(index);
                }}
                selectedIndex={tabIndexState}
            >
                <div className={'tabsListWrapper'}>
                    {!detectMobile() && (
                        <ControlsWrapper className={'left'} height={'32px'}>
                            <Button
                                display={'block'}
                                margin={'0 8px 0 0'}
                                padding={'0'}
                                width={'44px'}
                                height={'100%'}
                                lightBlue
                                onClick={scrollToLeft}
                                disabled={disabledLeftButton}
                            >
                                <img src={darkArrow} alt="" />
                            </Button>
                        </ControlsWrapper>
                    )}
                    <div
                        className={'TabListTopBarWrapper'}
                        id={'tabListWrapper'}
                    >
                        <TabList id={'tabList'}>{getTabItems(markets)}</TabList>
                    </div>
                    {!detectMobile() && (
                        <ControlsWrapper height={'32px'}>
                            <Button
                                display={'block'}
                                margin={'0 8px 0 0'}
                                padding={'0'}
                                width={'44px'}
                                height={'100%'}
                                lightBlue
                                onClick={scrollToRight}
                                disabled={disabledRightButton}
                            >
                                <img src={darkArrow} alt="" />
                            </Button>
                        </ControlsWrapper>
                    )}
                </div>

                <div className={`${!showBetbuilder() && 'hideBetbuilder'}`}>
                    {tabIndexState === 1 && (
                        <Hint
                            title={
                                detectMobile()
                                    ? HINT_TEXT.mobTitle
                                    : HINT_TEXT.title
                            }
                            label={HINT_TEXT.description}
                            breakTitle
                        />
                    )}
                    {checkConditionForBetRec(
                        markets[0]?.marketList[0]?.sportId
                    ) ? (
                        <CustomBetRecommendation
                            //userId={auth?.user?.userId || 0}
                            auth={auth}
                            isEventPage
                            eventId={eventId}
                        />
                    ) : null}
                </div>

                {tabPanel}
            </Tabs>
        </>
    );
};

export default GamePageTabView;
